var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.50039C9.59995 2.60039 6.39995 2.60039 4.49995 4.50039L6.59995 6.60039L0.199951 7.30039L0.899951 0.900391L3.09995 3.10039C5.89995 0.400391 10.3 0.400391 13 3.10039C14 4.10039 14.7 5.40039 14.9 6.90039L12.9 7.20039C12.7 6.20039 12.2 5.20039 11.5 4.50039Z",
    fill: "#F3C233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39995 9.40039L15.8 8.70039L15 15.1004L12.8 12.9004C11.5 14.2004 9.69995 14.9004 7.89995 14.9004C6.09995 14.9004 4.39995 14.3004 2.99995 12.9004C1.99995 11.9004 1.29995 10.6004 1.09995 9.10039L3.09995 8.80039C3.29995 9.80039 3.79995 10.8004 4.49995 11.5004C6.39995 13.4004 9.59995 13.4004 11.5 11.5004L9.39995 9.40039Z",
    fill: "#F3C233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.bdadeb1b665a555ef64cd3778824f7c5.svg";
export { ForwardRef as ReactComponent };